/* USERS */
export const GET_ITEMS = "GET_ITEMS"
export const GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS"
export const GET_ITEMS_FAIL = "GET_ITEMS_FAIL"